export let ENTITY_ID_USER = 1;
export let ENTITY_ID_ORGANIZATIONS = 3;
export let ENTITY_ID_ROLE = 4;
export let ENTITY_ID_AUDIT_LOGS = 5;
export let GENERIC_SETTINGS = 100;
export let ENTITY_ID_VEHICLE = 6;
export let ENTITY_ID_EXPENSE_CATEGORY = 7;


export let GENERIC_SETTING_TYPE_CURRENCY = 1;

// Not in DB
export let ENTITY_ID_PERMISSIONS = 9999;

export let ENTITY_ID_CUSTOMER_SALE = 200;
export let ENTITY_ID_RAW_PURCHASE = 202;
export let ENTITY_ID_SALES_CUSTOMER = 13;
export let ENTITY_ID_TAX_PLAN = 11;
export let ENTITY_ID_INVENTORY_ITEM = 12;
export let ENTITY_ID_SUPPLIER = 15;
export let ENTITY_ID_LEDGER_ACCOUNT = 17;
export let ENTITY_ID_ORGANIZATION_SETTINGS = 23;


export let ENTITY_ID_CLIENT_EXPENSE = 205;
export let ENTITY_ID_STOCK_YARD_INVENTORY = 206;

export let ENTITY_ID_EXPENSE_BANK_ACCOUNT = 1700;
export let ENTITY_ID_EXPENSE = 1600;

export let ENTITY_ID_QR_AUTO_PURCHASE_VEHICLE = 29;
